import { MenuItem, Select } from "@mui/material";
import { useViewPreference } from "~/hooks/use-view-preference";
import { FILE_VIEW_PREFERENCE_KEYS } from "~served/configs";
export const ViewPreference = () => {
  const viewPreference = useViewPreference();
  return <Select id="view-preference-select" size="small" value={viewPreference.fileViewPreference ?? null} onChange={async e => {
    await viewPreference.handleChangeViewPreference(e.target.value as unknown as FILE_VIEW_PREFERENCE_KEYS);
  }} data-sentry-element="Select" data-sentry-component="ViewPreference" data-sentry-source-file="view-preference.tsx">
			<MenuItem key={FILE_VIEW_PREFERENCE_KEYS.TABLE_VIEW} value={FILE_VIEW_PREFERENCE_KEYS.TABLE_VIEW} data-sentry-element="MenuItem" data-sentry-source-file="view-preference.tsx">
				Table
			</MenuItem>
			<MenuItem key={FILE_VIEW_PREFERENCE_KEYS.KANBAN_VIEW} value={FILE_VIEW_PREFERENCE_KEYS.KANBAN_VIEW} data-sentry-element="MenuItem" data-sentry-source-file="view-preference.tsx">
				Kanban
			</MenuItem>
		</Select>;
};